export enum SkjulSamtaleStatus {
  NotApplicable = 1,
  Success = 2,
  Failed = 3,
}
